import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '@app/shared/ui';
import { ToolbarComponent } from '../toolbar/toolbar';

@Component({
  selector: 'app-public',

  templateUrl: './public.html',
  imports: [RouterModule, ToolbarComponent, FooterComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicComponent {}
